import cn from 'classnames';
import React from 'react';

import ButtonRaw from '../ButtonRaw';
import styles from './AppButton.module.scss';

const AppButton = (props) => {
    const {className, primary, secondary, light, dark, tertiary, disabled, ...rest} = props;
    const classes = cn(
        {[styles.Button]: !tertiary},
        {
            [styles.PrimaryLight]: primary && light && !disabled,
            [styles.SecondaryLight]: secondary && light && !disabled,
            [styles.PrimaryDark]: primary && dark && !disabled,
            [styles.SecondaryDark]: secondary && dark && !disabled,
            [styles.Light]: light && !disabled,
            [styles.Dark]: dark && !disabled,
            [styles.Tertiary]: tertiary && !disabled,
            [styles.Active]: !disabled,
            [styles.Disabled]: disabled,
        },
        className
    );

    return <ButtonRaw className={classes} disabled={disabled} {...rest} />;
};

export default AppButton;
